<div class="modal-header">
    <h3 class="modal-title" id="modal-title">{{'KUNDORDER_DETAIL_FORSORJNINGSRAD_ADD'|translate}}</h3>
    <button id="modalFrcClose" type="button" class="btn-close" aria-describedby="skapa försörjningsrad" (click)="dismiss()"></button>
</div>

<div class="modal-body">
    <form [formGroup]="form">
        <rask-selector aid="forsorjningskalla" label="{{'KUNDORDER_DETAIL_FORSORJNINGSKALLA' | translate}}" formControlName="forsorjningskalla"
            [debounceTime]="300" [minCharacters]="3" [placeholder]="'DEFAULT_TYPE_AHEAD_HELP_TEXT' | translate"
            [search]="searchForsorjningskalla" [viewFormatter]="forsorjningskallaFormatter">
        </rask-selector>

        <rask-input-number aid="totalKvantitet" [label]="'KUNDORDER_DETAIL_FORDELNINGSANDEL'|translate" formControlName="totalKvantitet"
            [rule]=""></rask-input-number>
    </form>
</div>

<div class="modal-footer">
    <rask-button aid="buttonCreate" color="primary" (click)="create()">{{'DEFAULT_BUTTON_LABEL_LAGG_TILL'|translate}}
    </rask-button>
</div>
